import React from 'react';
import PropTypes from 'prop-types';

import PipelineTransformationsDrawerHeader from 'app/pipeline-details/PipelineTransformationsSection/PipelineTransformationsDrawer/shared/PipelineTransformationsDrawerHeader';
import PipelineTransformationsYamlEditor from 'app/pipeline-details/PipelineTransformationsSection/PipelineTransformationsDrawer/shared/PIpelineTransformationsYamlEditor';

export default function PipelineEventSplitDrawerContent({ eventSplit }) {
  return (
    <>
      <PipelineTransformationsDrawerHeader title="Pipeline Event Split" />
      <PipelineTransformationsYamlEditor name="pipeline-event-split" value={eventSplit} />
    </>
  );
}

PipelineEventSplitDrawerContent.propTypes = {
  eventSplit: PropTypes.object.isRequired,
};
